module.exports = __webpack_public_path__ + "img/experience_left_arrow.66a07a76.png";